<template>
  <div style="overflow:hidden">
    <div class="swiper header">
      <swiper class="swiper" :options="swiperOption">
        <!-- <swiper-slide class="swiper-slide image-center" style="background-image:url(https://file.lgbfss.com/www/official/images/timg.jpg)">
          <button class="learn-more">了解更多</button>
        </swiper-slide>-->
        <swiper-slide class="swiper-slide image-center">
          <a href="/website/about_us?tab=0">
            <div
              style="background-image:url(https://file.lgbfss.com/www/official/images/banner1.png);background-size:cover;height:100vh;"
            ></div>
            <!-- <img
              class="slide-img"
              src="https://file.lgbfss.com/www/official/images/banner1.png"
              alt
            />-->
          </a>
        </swiper-slide>
        <swiper-slide class="swiper-slide image-center">
          <a href="/website/about_us?tab=1">
            <img
              class="slide-img"
              src="https://file.lgbfss.com/www/official/images/banner2.png"
              alt
            />
          </a>
        </swiper-slide>
        <swiper-slide class="swiper-slide image-center">
          <a href="/website/about_us?tab=2">
            <img
              class="slide-img"
              src="https://file.lgbfss.com/www/official/images/banner3.jpg"
              alt
            />
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <Nav></Nav>
  </div>
</template>

<script>
import Nav from "./nav";

export default {
  data: () => {
    return {
      swiperOption: {
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 6000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: false,
      },
      pics: [
        {
          src: "https://file.lgbfss.com/www/official/images/banner1.jpg",
        },
      ],
    };
  },
  components: {
    Nav,
  },
  methods: {
    navHover (key) {
      this.hoverKey = key;
    },
    clearHover () {
      this.hoverKey = "";
    },
  },
};
</script>
<style lang="css" scoped>
.swiper-slide {
  height: 100vh;
}
.learn-more {
  padding: 10px 50px;
  border-radius: 20px;
  border: none;
  position: absolute;
  left: 50%;
  top: 80%;
  background: #5fccff;
  transform: translate(-50%, -50%);
}
.swiper {
  height: 100vh;
  width: 100vw;
}
.slide-img {
  display: inline-block;
  max-width: 100vw;
  /* height: auto; */
  height: 100vh;
}
</style>